import React, { useState } from "react";
import contact from "../assets/WhyUs/Contact.jpeg";
import CanonicalTag from "./CanonicalTag";
import { Helmet } from "react-helmet";
const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("firstName", formData.firstName);
    data.append("lastName", formData.lastName);
    data.append("email", formData.email);
    data.append("message", formData.message);

    try {
      const response = await fetch(
        "https://www.cementmachineryparts.in/sendMail.php",
        {
          method: "POST",
          body: data,
        }
      );

      const result = await response.text();

      if (result.toLowerCase().includes("success")) {
        alert("Message sent successfully!");
        setFormData({ firstName: "", lastName: "", email: "", message: "" });
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      } else {
        alert(result);
      }
    } catch (error) {
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <>
    {/* SEO Meta & Canonical */}
      <Helmet>
        <title>Conatct |Cement Machinery Parts</title>
        <meta
          name="description"
          content="Explore high-quality raw mill and conveyor equipment used in cement production. Designed for reliability and efficiency."
        />
      </Helmet>
      <CanonicalTag url="https://www.cementmachineryparts.in/contact" />
      <div className="contact">
        <img src={contact} alt="Contact" className="img-fluid w-100" />
      </div>

      <div className="container py-4">
        <div className="row">

          {/* Address */}
          <div className="col-12 col-md-6 col-lg-4 address p-3">
            <h4>
              <i className="fas fa-map-marker-alt text-danger me-2"></i>
              Address
            </h4>
            <p>
              Valerion Impex Pvt Limited<br />
              2nd Floor, Office no 4A, Chambers,<br />
              Purshottamdas Thakurdas Road,<br />
              Near Siddharth College, Fort,<br />
              Mumbai 400001, India.
            </p>
          </div>

          {/* Phone & Email */}
          <div className="col-12 col-md-6 col-lg-4 address p-3">
            <h4>
              <i className="fas fa-phone text-primary me-2"></i>
              Phone
            </h4>
            <p>+91 9820334961 / +91 98196 64898</p>
            <p>+91 22 22016014 / +91 22 22016015</p>

            <h4 className="mt-3">
              <i className="fas fa-envelope text-primary me-2"></i>
              Email
            </h4>
            <p>valerionimpexcement@gmail.com</p>
            <p>valerionimpex@gmail.com</p>
          </div>

          {/* Contact Form */}
          <div className="col-12 col-lg-4 p-3">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12 col-md-6 mb-3">
                  <label htmlFor="firstName" className="form-label">
                    First Name
                  </label>
                  <input              
                    type="text"
                    className="form-control"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label htmlFor="lastName" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
    
              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-danger w-100">
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
